const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/utils/form.ts';
import textMap from '../translations';
import { JaNeinOptions } from '../types';
import { FormatMessageFn } from '../../../defs/generalDefs';

export const getYesNoOptions = (
    formatMessage: FormatMessageFn,
    yesValue: JaNeinOptions | string = JaNeinOptions.Ja,
    noValue: JaNeinOptions | string = JaNeinOptions.Nein
) => {
    return [
        { label: formatMessage(textMap.ja), value: yesValue },
        { label: formatMessage(textMap.nein), value: noValue },
    ];
};

export const validateForm = (formRefValue: any) => {
    if (formRefValue) {
        return formRefValue.checkSave();
    }
    throw Error('Cannot validate form because formRef does not have the "current" property.');
};
